import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { OperationModificative } from '../texte.model';

@Injectable({providedIn: 'root'})
@Pipe({
	name: 'positionCible',
	pure: false // La classe ne modifie pas son argument mais c'est nécessaire
})
export class PositionCiblePipe implements PipeTransform {

	transform(operation: OperationModificative): string {
		if (operation.txt_cible == undefined || operation.tot_code != 'ajo') {
			return '';
		}

		for (let article of operation.txt_cible.articles) {
			if (operation.art_id_position === article.art_id) {
				let titre = (article.art_titre ?? 'null').toString();
				if (titre.toLowerCase().startsWith('article')) {
					return "Avant l'article `" + titre.slice('article'.length).trim() + '`';
				}
				return "Avant l'article `" + article.art_titre + '`'
			}
		}
		return 'À la fin'
	}
}
